
/*
Todo
2. Ele going out of box;
3. Perfect center postion of last ele.
*/
const restrictBoundary = (lastEle, shapesWrapperEle) => {
  if (lastEle.offsetTop < 0) {
    shapesWrapperEle.style.top = `${-(lastEle.offsetTop)}px`;
  }
  if (lastEle.offsetLeft < 0) {
    shapesWrapperEle.style.left = `${-(lastEle.offsetLeft)}px`;
  }
};
export const positionEle = (data = [], index) => {
  const { length } = data;
  if (length >= 2) {
    const currentActiveEle = data[index] || {};
    const last = data[length - 1];
    const lastEleId = last.id;
    const secLastEleId = currentActiveEle.id;
    const shapesWrapperEle = document.getElementById('shapesWrapper');
    const zoomingArea = document.getElementById('zoomingArea');
    const lastEle = document.getElementById(lastEleId);
    const secLastEle = document.getElementById(secLastEleId);
    if (!shapesWrapperEle || !secLastEle || !lastEle) {
      return false;
    }
    const { top: parentTop, left: parentLeft } = shapesWrapperEle.getBoundingClientRect();
    const {
      top: childTop, left: childLeft, width: secLastWidth, height: secLastHeight,
    } = secLastEle.getBoundingClientRect();
    const { width: lastWidth } = lastEle.getBoundingClientRect();
    const centerVal = (secLastWidth - lastWidth) / 2;
    const { scrollTop } = shapesWrapperEle;
    const { scrollLeft } = shapesWrapperEle;
    const { position = 'bottom' } = currentActiveEle;
    const top = (childTop - parentTop) + scrollTop;
    const left = ((childLeft - parentLeft) + scrollLeft) + centerVal;
    if (position === 'bottom') {
      lastEle.style.top = `${top + secLastHeight + 50}px`;
      lastEle.style.left = `${left}px`;
    } else if (position === 'bottomRight') {
      lastEle.style.top = `${top + secLastHeight + 100}px`;
      lastEle.style.left = `${left + 250}px`;
    } else if (position === 'bottomLeft') {
      lastEle.style.top = `${top + secLastHeight + 100}px`;
      lastEle.style.left = `${left - 250}px`;
    } else if (position === 'right') {
      lastEle.style.top = `${top}px`;
      lastEle.style.left = `${left + 250}px`;
    } else if (position === 'topRight') {
      lastEle.style.top = `${top + secLastHeight - 100}px`;
      lastEle.style.left = `${left + 250}px`;
    } else if (position === 'left') {
      lastEle.style.top = `${top}px`;
      lastEle.style.left = `${left - 250}px`;
    } else if (position === 'topLeft') {
      lastEle.style.top = `${top + secLastHeight - 100}px`;
      lastEle.style.left = `${left - 250}px`;
    } else if (position === 'top') {
      lastEle.style.top = `${top - 150}px`;
      lastEle.style.left = `${left}px`;
    }
    restrictBoundary(lastEle, shapesWrapperEle);
    zoomingArea.scrollTop = lastEle.offsetTop;
    zoomingArea.scrollLeft = lastEle.offsetLeft;
  }
  return false;
};
